import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getSuperTenant, type SuperTenantDetail as TenantDetail } from "../api/super";
import { ApiError } from "../api/client";
import { PageHeader } from "../components/Chrome";

// S2 — single tenant overview (Foundry team only). Read-only summary
// of branding + status + spec hash. Operational changes (provision,
// reconcile) happen out-of-band via CLI; this is the at-a-glance view.
export function SuperTenantDetail() {
  const { slug } = useParams<{ slug: string }>();
  const [tenant, setTenant] = useState<TenantDetail | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!slug) return;
    void (async () => {
      try {
        setTenant(await getSuperTenant(slug));
      } catch (e) {
        setError(e instanceof ApiError ? e.detail : (e as Error).message);
      }
    })();
  }, [slug]);

  if (error) return <div className="container"><div className="empty err">{error}</div></div>;
  if (!tenant) return <div className="container"><div className="empty">Loading…</div></div>;

  return (
    <div className="container">
      <PageHeader title={tenant.display_name} eyebrow="Foundry super-admin">
        <Link to="/admin/super" className="btn-link">← All tenants</Link>
      </PageHeader>
      <div className="meta-grid">
        <div>
          <span className="meta-label">Slug</span>
          <code>{tenant.slug}</code>
        </div>
        <div>
          <span className="meta-label">Status</span>
          <span>{tenant.status}</span>
        </div>
        <div>
          <span className="meta-label">Application name</span>
          <span>{tenant.application_name}</span>
        </div>
        <div>
          <span className="meta-label">Domain</span>
          <span>{tenant.domain ?? "—"}</span>
        </div>
        <div>
          <span className="meta-label">Primary color</span>
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span
              style={{
                display: "inline-block",
                width: 18,
                height: 18,
                borderRadius: 4,
                background: tenant.primary_color,
                border: "1px solid var(--hair)",
              }}
            />
            <code>{tenant.primary_color}</code>
          </span>
        </div>
        <div>
          <span className="meta-label">Spec hash</span>
          <code style={{ fontSize: 11 }}>
            {tenant.current_spec_hash?.slice(0, 12) ?? "—"}
          </code>
        </div>
        <div>
          <span className="meta-label">Created</span>
          <span>{tenant.created_at}</span>
        </div>
      </div>
    </div>
  );
}
